"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');






var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _user = require('shared/selectors/user');



var _broadcast = require('shared/selectors/broadcast');
var _team = require('shared/selectors/team');
var _time = require('shared/services/time');
var _broadcastGate = require('shared/services/broadcastGate');

var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');


var _useCampaignSchedule = require('web/screens/Broadcast/useCampaignSchedule');

/* onGateRefused receives the launch gate's result when the server refuses a
 * start, so the Send dialog can show it instead of a notice bar. */
const useCampaignActions = (
  campaignKey,
  onGateRefused,
) => {
  const orgKey = _hooks.useAppSelector.call(void 0, s => _broadcast.selectCampaignOrgKey.call(void 0, s, campaignKey))
  const amIAnAdmin = _hooks.useAppSelector.call(void 0, s => !!(orgKey && _user.selectAmIAdminInOrg.call(void 0, s, orgKey)))
  const teamKey = _hooks.useAppSelector.call(void 0, s => _broadcast.selectCampaignTeamKey.call(void 0, s, campaignKey))
  const team = _hooks.useAppSelector.call(void 0, s => teamKey ? _team.selectTeamByKey.call(void 0, s, teamKey) : null)
  const teamPhoneNumber = _optionalChain([team, 'optionalAccess', _ => _.PhoneNumber])

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  // Rev 28 R3: a schedule shows as Scheduled from the chosen time at once.
  const onStartCampaign = _react.useCallback.call(void 0, 
    (patientsCount, scheduleAt) => {
      if (scheduleAt) _useCampaignSchedule.seedStartTime.call(void 0, campaignKey, scheduleAt)
      return _actions2.default
        .startCampaign(campaignKey, patientsCount, scheduleAt)
        .then(() => scheduleAt ? _useCampaignSchedule.confirmStartTime.call(void 0, campaignKey) : _useCampaignSchedule.forgetStartTime.call(void 0, campaignKey))
        .catch(e => {
          _useCampaignSchedule.dropStartTime.call(void 0, campaignKey)
          const gate = _broadcastGate.campaignGateFromError.call(void 0, e)
          if (gate) return onGateRefused(gate)
          log.error(e )
          const reason = typeof _optionalChain([e, 'optionalAccess', _2 => _2.Error]) === 'string' ? e.Error : null
          showWarningBar(reason ? `Couldn't start campaign: ${reason}` : "Couldn't start campaign")
        })
    },
    [campaignKey, showWarningBar, onGateRefused],
  )
  // Rev 33 T2: one Pause. StopCampaign stops sending and returns every
  // queued message to Not scheduled (sent and in-flight ones are untouched).
  const onPauseCampaign = _react.useCallback.call(void 0, 
    () => _actions2.default
      .stopCampaign(campaignKey)
      .then(() => _useCampaignSchedule.forgetStartTime.call(void 0, campaignKey))
      .catch((e) => {
        log.error(e )
        showWarningBar("Couldn't pause the campaign")
      }),
    [campaignKey, showWarningBar],
  )
  const handleExportCampaign = _react.useCallback.call(void 0, 
    async (FromDate, ToDate) => {
      if (!orgKey) return
      showSuccessBar('Campaign export has been requested')

      return _actions2.default.exportPhoneLogs({
        OrgKey: orgKey,
        FromNumber: teamPhoneNumber || '',
        FromDate,
        ToDate,
        TimeZone: _time.userTZ ,
      })
        .then(link => window.open(link, "_self"))
        .catch(() => showWarningBar('Failed to export campaign'))
    },
    [orgKey, teamPhoneNumber, showWarningBar, showSuccessBar],
  )
  const onExportCampaign = amIAnAdmin ? handleExportCampaign : null

  const onRemovePatients = _react.useCallback.call(void 0, 
    (patientKeys) => _actions2.default.removePatientsFromCampaign(campaignKey, patientKeys),
    [campaignKey],
  )
  const onDequeuePatients = _react.useCallback.call(void 0, 
    (patientKeys) => _actions2.default.dequeuePatientsInCampaign(campaignKey, patientKeys),
    [campaignKey],
  )

  return {
    onStartCampaign,
    onPauseCampaign,
    onExportCampaign,
    onRemovePatients,
    onDequeuePatients,
  }
}

exports. default = useCampaignActions
